import { useLayoutEffect } from "react";

import { AGENT_SIDEBAR_DOCK_BREAKPOINT } from "src/components/layout/page-sidebar/agent/constants";
import { useIsScreenAtLeast } from "src/hooks/use-is-large-screen";

/**
 * For a contained page, whose window never scrolls. The gutter global-styles
 * reserves for the window's scrollbar would sit empty at its right edge, beside
 * the docked agent rail, so the page releases it while it is mounted.
 */
export const useReleasedScrollbarGutter = () => {
  // Undocked, the overlaid rail's hidden menus can overflow the window, and the reserved gutter keeps that from shifting the page.
  const isDocked = useIsScreenAtLeast(AGENT_SIDEBAR_DOCK_BREAKPOINT);
  useLayoutEffect(() => {
    if (!isDocked) return;
    const html = document.documentElement;
    const previousGutter = html.style.scrollbarGutter;
    html.style.scrollbarGutter = "auto";
    return () => {
      html.style.scrollbarGutter = previousGutter;
    };
  }, [isDocked]);
};
